import { render, staticRenderFns } from "./SapDeliveryLogisticsRecord.vue?vue&type=template&id=237d0fed&scoped=true"
import script from "./SapDeliveryLogisticsRecord.vue?vue&type=script&lang=js"
export * from "./SapDeliveryLogisticsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d0fed",
  null
  
)

export default component.exports